import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

export default function Room({ user }) {
  const [roomId, setRoomId] = useState("");
  const navigate = useNavigate();

  const handleCreateRoom = () => {
    const newRoomId = uuidv4(); // generate unique room ID
    navigate(`/chat/${newRoomId}`);
  };

  const handleJoinRoom = (e) => {
    e.preventDefault();
    if (roomId.trim()) {
      navigate(`/chat/${roomId.trim()}`);
    } else {
      alert("Please enter a valid room ID.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(120deg, #1e1e60, #3b3ba3)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontFamily: "'Segoe UI', sans-serif",
        padding: "20px",
      }}
    >
      <h1 style={{ marginBottom: "30px" }}>Welcome, {user.name}</h1>

      <form onSubmit={handleJoinRoom} style={{ textAlign: "center" }}>
        <input
          type="text"
          value={roomId}
          onChange={(e) => setRoomId(e.target.value)}
          placeholder="Enter Room ID to Join"
          style={{
            padding: "12px 20px",
            fontSize: "16px",
            borderRadius: "8px",
            border: "none",
            marginBottom: "20px",
            width: "250px",
          }}
        />
        <br />
        <button
          type="submit"
          style={{
            background: "#00c9a7",
            padding: "12px 24px",
            fontSize: "16px",
            borderRadius: "8px",
            border: "none",
            color: "#fff",
            fontWeight: "bold",
            marginBottom: "20px",
            cursor: "pointer",
          }}
        >
          Join Room
        </button>
      </form>

      <p>— OR —</p>

      <button
        onClick={handleCreateRoom}
        style={{
          background: "#ff4d4f",
          padding: "12px 24px",
          fontSize: "16px",
          borderRadius: "8px",
          border: "none",
          color: "#fff",
          fontWeight: "bold",
          marginTop: "20px",
          cursor: "pointer",
        }}
      >
        Create New Room 🔗
      </button>
    </div>
  );
}
